import { isEmptyOrNull } from '@tecsinapse/es-utils/build'
import { gql } from 'graphql-request'
import React, { ReactNode } from 'react'
import { Loading } from './loading'
import { useQuery } from '@tanstack/react-query'
import { request } from '../utils/request'
import { ArquivoQueryQuery, ArquivoQueryQueryVariables } from '../types/graphql'

export const arquivoQueryGql = gql`
  query ArquivoQuery($idArquivo: ID!) {
    arquivo(idArquivo: $idArquivo) {
      id
      nome
      tamanho
    }
  }
`

export const linkDownloadByArquivoQueryGql = gql`
  query LinkDownloadByArquivoQuery($idArquivo: ID!) {
    linkDownloadByArquivo(idArquivo: $idArquivo)
  }
`

export const downloadByLink = url => {
  const link = document.createElement('a')

  link.href = url
  link.target = '_blank'
  link.click()
}

export const downloadByButton = url => {
  const button = document.createElement('button')

  button.addEventListener('click', () => {
    window.open(url, '_blank')
  })

  button.click()
}

export const UploadedFile = ({
  idArquivo,
  children
}: {
  idArquivo: string
  children: ReactNode
}) => {
  const { data: { arquivo } = {}, isLoading: loading } = useQuery({
    queryKey: ['arquivo', idArquivo],
    queryFn: async () =>
      await request<ArquivoQueryQuery, ArquivoQueryQueryVariables>(
        arquivoQueryGql,
        {
          variables: { idArquivo }
        }
      ),
    enabled: !isEmptyOrNull(idArquivo)
  })

  if (loading) {
    return <Loading />
  }

  return children ? children({ arquivo: arquivo || null }) : null
}
